import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';

import { WorkTimeEntryBreak } from 'record-it-time-common/entity/entities/WorkTimeEntry/WorkTimeEntryDto';

import { WorkTimeEntryToCreate } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { ValidationFn } from '../useValidation';

export function validateBreak(
  workTimeEntryBreak:
    | WorkTimeEntryBreak
    | Pick<WorkTimeEntryBreak, 'startDate' | 'endDate'>,
  workTimeEntry: WorkTimeEntryToCreate
): ValidationFn {
  const dateUtils = DateUtils.withCurrentTimezone();
  return (t) => {
    const breakStartDate = new Date(workTimeEntryBreak.startDate);
    const breakEndDate = new Date(workTimeEntryBreak.endDate);

    if (breakEndDate < breakStartDate) {
      return t('hooks.validation.functions.validateBreak.endBeforeStartDate');
    }

    if (
      breakStartDate < dateUtils.getDate(workTimeEntry.startDate) ||
      breakStartDate > dateUtils.getDate(workTimeEntry.endDate)
    ) {
      return t(
        'hooks.validation.functions.validateBreak.breakMustOccurInWorkTime'
      );
    }

    if (
      breakEndDate < dateUtils.getDate(workTimeEntry.startDate) ||
      breakEndDate > dateUtils.getDate(workTimeEntry.endDate)
    ) {
      return t(
        'hooks.validation.functions.validateBreak.breakMustOccurInWorkTime'
      );
    }

    if (
      !workTimeEntry.breaks.every((existingBreak) => {
        if (existingBreak === workTimeEntryBreak) return true;

        const existingBreakStartDate = new Date(existingBreak.startDate);
        const existingBreakEndDate = new Date(existingBreak.endDate);

        return !(
          (breakStartDate >= existingBreakStartDate &&
            breakStartDate < existingBreakEndDate) ||
          (breakEndDate > existingBreakStartDate &&
            breakEndDate <= existingBreakEndDate) ||
          (breakStartDate <= existingBreakStartDate &&
            breakEndDate >= existingBreakEndDate)
        );
      })
    ) {
      return t(
        'hooks.validation.functions.validateBreak.breakMustNotOverlapWithExistingBreak'
      );
    }

    return undefined;
  };
}
